import useGetUsers from 'modules/fund/tabs/hooks/useGetUsers'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'

export default function useSetUser(poolShip: number | undefined) {
    const [selectUser, setSelectUser] = useState<
        undefined | IMoneyPoolResults
    >()
    const { moneyPool } = useParams()
    const { data } = useGetUsers(moneyPool)
    useEffect(() => {
        if (data && poolShip) {
            console.log('sdsvs', data)
            const select = data.pages
                .flatMap((x) => x.results)
                .find((item) => item.id === poolShip)
            setSelectUser(select)
        }
    }, [poolShip, data])
    return { selectUser }
}
